export default {
  default: {
    sweetAlert: {
      confirm: 'Yes, delete it?',
      text: 'Are you sure?',
      title: 'Delete Section?',
    },
  },
}
